import { authHeader } from "@/services/auth";
import { isoStringToNormalDate } from "@/services/util.service";
import { doPostIncident } from "@/services/incident.service";
import { removeCookieByName } from "@/services/auth";
import { errorHandler } from '@/services/error-handler'

//import { loginInterrupt } from "@/services/nav";
import store from "@/stores/index";
const vueOrgId = import.meta.env.VITE_APP_ORGANIZATION_ID;
const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;
// Define routes where we DON'T want to interrupt login (match exact path or subpaths)
const excludedPaths = [
  "/gate/sign-in",
  "/gate/sign-up",
  "/gate/forgot-password",
  "/gate/reset-password",
];

const isExcludedPath = (pathname) =>
  excludedPaths.some((p) => pathname === p || pathname.startsWith(`${p}/`));

export const gqlHandleError = async (error, params, url, authRequired) => {
  console.log("GraphQL error handler called", error);

  const userAgent = navigator;
  const currentdate = await isoStringToNormalDate();

  let status = error?.status || 500;
  let description = "Unexpected error while communicating with the cloud";
  let metadataError = "";
  let isAuthError = error?.isAuthError

  if (error?.userErrors && error.userErrors.length > 0) {
    const userError = error.userErrors[0];
    description = userError.message || description;
    metadataError = JSON.stringify(userError);
  }

  if (error?.graphQLErrors && error.graphQLErrors.length > 0) {
    const gqlError = error.graphQLErrors[0];

    const isGraphqlAuthError =
      gqlError?.extensions?.category == "graphql-authentication" || gqlError?.extensions?.category == "graphql-authorization";

    if (isGraphqlAuthError) {
      if (authRequired) {
        isAuthError = isGraphqlAuthError
        const url = new URL(window.location.href);

        if (!isExcludedPath(url.pathname)) {
          store.dispatch("auth/triggerLoginPopup",
            "Your session has expired. Please log back in to continue.<br>You may return home, but you will lose your progress."
          );
        }
        // resetAuthUser();
        /*loginInterrupt(
          window.location.href,
          "There was an access violation caused by your request. You need to sign back in please."
        );*/

      }
      // Use window.location.pathname (only the path, not full URL)
      // const currentPath = window.location.pathname;

    }

    status = 200;
    description = gqlError.message || "GraphQL API Error";

    if (
      description.includes("The cart isn't active") ||
      description.includes("Could not find a cart")
    ) {
      removeCookieByName(crGuestQuoteId);
      window.location.reload();
    }
    metadataError = JSON.stringify(gqlError);
  } else if (error?.response) {
    status = error.response.status;
    description = "Storefront Error " + status;
    try {
      metadataError = await error.response.text();
    } catch {
      metadataError = "error in response.text()";
    }
  } else if (error?.message) {
    description = error.message;
    metadataError = JSON.stringify(error);
  } else {
    metadataError = JSON.stringify(error);
  }

  // send error to datadog error handler
  errorHandler.send(error, {
    type: 'graphql-api-error',
    status,
    url,
    params,
    errorDetails: metadataError,
  })

  // Incident object
  const obj = {
    title: "Storefront Error " + (status || "GraphQL"),
    app_id: "crane",
    level: "minor",
    description,
    module: "storefront",
    tags: [],
    recorded_at: currentdate,
    organization_id: vueOrgId,
    metadata: {
      authHeader: authHeader ? authHeader() : "",
      body: params,
      error: metadataError,
      url,
      status,
      platform: userAgent.platform,
      appVersion: userAgent.appVersion,
      appCodeName: userAgent.appCodeName
    }
  };

  try {
    await doPostIncident(obj);
  } catch (incidentErr) {
    console.log("Error while posting incident", incidentErr);
  }

  throw { message: description, isAuthError, status };
};
